//angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

//local
import { SecurityConfig } from '@app/core';
import { ApiConstants, HttpResult, PollyHttpHelper } from '@app/shared';
import { ProjectPropertyDto, CreateProjectRequest, UpdateProjectRequest, ExportPackageRequest } from '@app/catalog';

@Injectable({
    providedIn: 'root'
})
export class ProjectHttpService 
{
    constructor(
      private http: HttpClient, 
      private applicationConfig: SecurityConfig) {    
    }


    public getProperties(projectId: string): HttpResult<ProjectPropertyDto> 
    {
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/catalog/project/${projectId}`;
            
      console.log(`GET: ${serviceUri}`); 
      
      return PollyHttpHelper.Invoke('GET', () => this.http.get<ProjectPropertyDto>(serviceUri, { headers: ApiConstants.DefaultHeaders }));
    }

    public create(request: CreateProjectRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/project`;
            
      console.log(`POST: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('POST', () => this.http.post<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }

    public update(projectId: string, request: UpdateProjectRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/project/${projectId}`;
            
      console.log(`PUT: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('PUT', () => this.http.put<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }

    public exportPackage(request: ExportPackageRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/exportpackage`;
            
      console.log(`POST: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('POST', () => this.http.post<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }
}